import React, { useState } from "react";


function PlacesAutocomplete({ onSelect }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  const handleSearch = async (q) => {
    setQuery(q);
    if (q.length < 3) {
      setResults([]);
      return;
    }

    try {
      const res = await fetch(
        `https://photon.komoot.io/api/?q=${encodeURIComponent(q)}&lang=de`
      );
      const data = await res.json();
      setResults(data.features);
    } catch (err) {
      console.error("Fehler bei Photon:", err);
    }
  };

  const handleSelect = (feature) => {
    const formatted = `${feature.properties.street || ""} ${feature.properties.housenumber || ""}, ${feature.properties.city || feature.properties.town || feature.properties.village || ""}`;

    // Inputfeld setzen
    setQuery(formatted);
    setResults([]);

    if (onSelect) {
      onSelect({
        address: formatted,
        lat: feature.geometry.coordinates[1],
        lon: feature.geometry.coordinates[0],
      });
    }
  };

  return (
    <div className="autocomplete-container">
      <input
        style={{ width: "100%" }}
        className="autocomplete-input"
        type="text"
        value={query}
        placeholder="Adresse eingeben"
        onChange={(e) => handleSearch(e.target.value)}
      />
      {results.length > 0 && (
        <div className="autocomplete-dropdown">
          {results.map((r, idx) => (
            <div
              key={idx}
              className="autocomplete-item"
              onClick={() => handleSelect(r)}
            >
              {r.properties.street || r.properties.name || "Unbenannt"}{" "}
              {r.properties.housenumber || ""},{" "}
              {r.properties.city || r.properties.town || r.properties.village || ""}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
export default PlacesAutocomplete;
